import type { NextPage } from "next";
import Head from "next/head";

import Landing from "@components/Landing";

const Header = () => (
  <Head>
    <title>
      Kelp – The Leading Liquid Restaking Protocol | Restake Ethereum & Stay
      Liquid
    </title>
    <meta
      name="description"
      content="Kelp is a top restaking protocol with $2B+ TVL. Restake Ethereum (ETH) and other assets while maintaining liquidity with rsETH, live on 40+ DeFi platforms. Maximize your DeFi stake rewards today."
    />
    <link rel="icon" href="/favicon.ico" type="image/x-icon" sizes="96x96" />
    <meta name="robots" content="index, follow" />
  </Head>
);

const Home: NextPage = () => {
  return (
    <>
      <Header />
      <Landing />
    </>
  );
};

export default Home;
